"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _reselect = require("reselect");

var _default = function _default(location) {
  var getStore = function getStore(state) {
    return state[location];
  };

  return {
    // Gets the base store
    getStore: getStore,
    // Gets the error state of the store
    getError: (0, _reselect.createSelector)(getStore, function (store) {
      return store.error;
    }),
    // Gets the data within the store
    getData: (0, _reselect.createSelector)(getStore, function (store) {
      return store.data;
    }),
    // Get loading state of store
    getIsLoading: (0, _reselect.createSelector)(getStore, function (store) {
      return store.loading;
    })
  };
};

exports["default"] = _default;